import styled from "styled-components";
import { themeGet } from "@fuegokit/react";

export const Paragraph = styled.p`
  font-size: ${themeGet("fontSizes.5")};
  margin: ${themeGet("space.3")} 0;
  line-height: ${themeGet("lineHeights.default")};
`;
